/** Shared helpers for day-wise / summary usersEarning buckets */

export const USERS_EARNING_LABELS = {
	0: "0–60",
	61: "61–125",
	126: "126–250",
	251: "251–625",
	"626+": "626+",
};

export const BUCKET_ORDER = [0, 61, 126, 251, "626+"];

export const BUCKET_COLORS = {
	0: "#94A3B8",
	61: "#3B82F6",
	126: "#10B981",
	251: "#F59E0B",
	"626+": "#8B5CF6",
};

export const formatUsersEarningForTable = (buckets = []) => {
	const map = new Map(buckets.map((b) => [b._id, b.total_users ?? 0]));
	return BUCKET_ORDER.map((id) => ({
		id,
		label: USERS_EARNING_LABELS[id],
		total_users: map.get(id) ?? 0,
	}));
};

export const bucketKey = (id) => `b_${String(id)}`;

/** One chart row from a usersEarning array */
export const bucketsToRow = (buckets = []) => {
	const row = {};
	formatUsersEarningForTable(buckets).forEach((b) => {
		row[bucketKey(b.id)] = b.total_users;
	});
	return row;
};
